import type { MailboxInfo } from 'owa-client-types';
import { owaDate } from 'owa-datetime';
import {
    type AccountOcpsPoliciesState,
    OcpsPoliciesFetchState,
} from '../store/schema/OutlookCloudPoliciesSchema';

type RefreshOcpsPolicies = (mailboxInfo: MailboxInfo) => void;

let refreshOcpsPolicies: RefreshOcpsPolicies | undefined;

export function registerOcpsPoliciesRefresh(refresh: RefreshOcpsPolicies): void {
    refreshOcpsPolicies = refresh;
}

export function refreshOcpsPoliciesIfExpired(
    mailboxInfo: MailboxInfo,
    accountPolicies: AccountOcpsPoliciesState | undefined
): void {
    if (
        !accountPolicies ||
        (accountPolicies.fetchState !== OcpsPoliciesFetchState.Succeeded &&
            accountPolicies.fetchState !== OcpsPoliciesFetchState.Failed)
    ) {
        return;
    }

    const refreshDeadline =
        accountPolicies.fetchState === OcpsPoliciesFetchState.Failed
            ? accountPolicies.retryAfter
            : accountPolicies.expirationTime;

    if (refreshDeadline && owaDate('UTC') >= refreshDeadline) {
        refreshOcpsPolicies?.(mailboxInfo);
    }
}
